/** Fase 2 (W6, L12 e L13): textos das telas de Serviços, Formas e Condições de pagamento (namespace `cadastros`). */
export const catalogosPt = {
  servicos: {
    novo: 'Novo serviço',
    importar: 'Importar serviços',
    vazio: 'Cadastre o primeiro serviço ou importe uma planilha. O catálogo serve para vender e para comprar, e a Agenda usa os agendáveis.',
    excluir: 'Excluir',
    excluirTitulo: 'Excluir este serviço?',
    excluirTexto: 'Ele sai do catálogo. Serviço em uso por outro módulo não é excluído; a mensagem diz onde ele está em uso.',
    campos: {
      nome: 'Nome', codigo: 'Código', descricao: 'Descrição', uso: 'Uso', agendavel: 'Agendável', preco: 'Preço de venda', custo: 'Custo',
      tipoCobranca: 'Cobrança', centro: 'Centro de custo padrão', categoria: 'Categoria padrão', ativo: 'Ativo', margem: 'Margem',
      duracao: 'Duração (min)', quemFaz: 'Quem faz na Agenda',
    },
    ajuda: {
      padrao: 'Só uma sugestão para quem usar o serviço; dá para trocar no documento.',
      agendavel: 'Aparece para quem agenda.',
      duracao: 'Tempo que o agendamento ocupa. Sem valor, a Agenda usa 60 minutos.',
      quemFaz: 'Sem marcar nenhum, qualquer profissional ou recurso ativo faz o serviço.',
    },
    usos: { venda: 'Venda', compra: 'Compra', ambos: 'Venda e compra' },
    cobrancas: { recorrente: 'Recorrente', avulso: 'Avulso' },
    filtros: { uso: 'Uso', todos: 'Todos os usos' },
  },
  // Fase 2 (W31, 5.2): serviços contratados de terceiros (o que a empresa compra).
  contratados: {
    novo: 'Novo serviço',
    importar: 'Importar serviços contratados',
    vazio: 'Cadastre os serviços que a empresa contrata de terceiros, como contabilidade, limpeza ou hospedagem. A compra sugere a categoria de despesa e o fornecedor de cada um.',
    excluirTitulo: 'Excluir este serviço contratado?',
    excluirTexto: 'Ele vai para a lixeira por 30 dias. Serviço em uso por outro módulo não é excluído; a mensagem diz onde ele está em uso.',
    campos: { nome: 'Nome', descricao: 'Descrição', categoria: 'Categoria de despesa', fornecedor: 'Fornecedor padrão', valorReferencia: 'Valor de referência', ativo: 'Ativo' },
    ajuda: { categoria: 'Do plano de contas do Financeiro. Sugestão para a compra; dá para trocar no item.', fornecedor: 'Opcional. Sugestão para quem compra o serviço.', valorReferencia: 'Opcional. A compra sugere este valor no item; dá para trocar.' },
    filtros: { situacao: 'Situação', ativos: 'Ativos', inativos: 'Inativos', todos: 'Todos' },
  },
  formas: {
    nova: 'Nova forma',
    importar: 'Importar formas de pagamento',
    vazio: 'Cadastre os meios de pagamento pelo tipo e pela abreviatura, como Pix Sicredi ou Boleto Asaas. Dá para ter mais de um do mesmo tipo, com abreviaturas diferentes.',
    ajudaAbreviatura: 'Distingue formas do mesmo tipo, como Sicredi ou Itaú. O nome fica o tipo mais a abreviatura: Pix Sicredi.',
    excluirTitulo: 'Excluir esta forma de pagamento?',
    excluirTexto: 'Ela sai da lista. Forma em uso por outro módulo não é excluída.',
    campos: { nome: 'Nome', tipo: 'Tipo', abreviatura: 'Abreviatura', descricao: 'Descrição', ativa: 'Ativa' },
    tipos: { pix: 'Pix', boleto: 'Boleto', transferencia: 'Transferência', cartao_credito: 'Cartão de crédito', cartao_debito: 'Cartão de débito', dinheiro: 'Dinheiro', cheque: 'Cheque', outro: 'Outro' },
  },
  condicoes: {
    nova: 'Nova condição',
    importar: 'Importar condições de pagamento',
    vazio: 'Cadastre os prazos com nome, como "30, 60 e 90 dias". O código é o mesmo que Contas e Compras já usam.',
    excluirTitulo: 'Excluir esta condição de pagamento?',
    excluirTexto: 'Ela sai da lista. Documentos que já usam o código não mudam.',
    campos: { nome: 'Nome', codigo: 'Código', prazos: 'Prazos', ativa: 'Ativa' },
    ajudaCodigo: 'avista, 30 ou 30/60/90 (dias depois da data base, em ordem crescente).',
    avista: 'À vista',
    dias_one: '{{count}} dia',
    dias_other: '{{count}} dias',
  },
};

type Dic = typeof catalogosPt;

export const catalogosEn: Dic = {
  servicos: {
    novo: 'New service',
    importar: 'Import services',
    vazio: 'Add the first service or import a spreadsheet. The catalog works for selling and buying, and the Calendar uses the bookable ones.',
    excluir: 'Delete',
    excluirTitulo: 'Delete this service?',
    excluirTexto: 'It leaves the catalog. A service used by another module is not deleted; the message says where it is in use.',
    campos: {
      nome: 'Name', codigo: 'Code', descricao: 'Description', uso: 'Use', agendavel: 'Bookable', preco: 'Sale price', custo: 'Cost',
      tipoCobranca: 'Billing', centro: 'Default cost center', categoria: 'Default category', ativo: 'Active', margem: 'Margin',
      duracao: 'Duration (min)', quemFaz: 'Who does it in the Calendar',
    },
    ajuda: {
      padrao: 'Just a suggestion for whoever uses the service; it can be changed on the document.',
      agendavel: 'Shows up for booking.',
      duracao: 'Time the appointment takes. With no value, the Calendar uses 60 minutes.',
      quemFaz: 'With none checked, any active professional or resource does the service.',
    },
    usos: { venda: 'Sale', compra: 'Purchase', ambos: 'Sale and purchase' },
    cobrancas: { recorrente: 'Recurring', avulso: 'One-off' },
    filtros: { uso: 'Use', todos: 'All uses' },
  },
  contratados: {
    novo: 'New service',
    importar: 'Import contracted services',
    vazio: 'Add the services the company hires from third parties, such as accounting, cleaning or hosting. Purchases suggest the expense category and the supplier of each one.',
    excluirTitulo: 'Delete this contracted service?',
    excluirTexto: 'It goes to the trash for 30 days. A service in use by another module is not deleted; the message says where it is in use.',
    campos: { nome: 'Name', descricao: 'Description', categoria: 'Expense category', fornecedor: 'Default supplier', valorReferencia: 'Reference price', ativo: 'Active' },
    ajuda: { categoria: 'From the Finance chart of accounts. A suggestion for the purchase; you can change it on the item.', fornecedor: 'Optional. A suggestion for whoever buys the service.', valorReferencia: 'Optional. Purchases suggest this price on the item; you can change it.' },
    filtros: { situacao: 'Status', ativos: 'Active', inativos: 'Inactive', todos: 'All' },
  },
  formas: {
    nova: 'New method',
    importar: 'Import payment methods',
    vazio: 'Add payment methods by type and short name, such as Pix Sicredi or Boleto Asaas. You can have more than one of the same type, with different short names.',
    ajudaAbreviatura: 'Tells apart methods of the same type, such as Sicredi or Itaú. The name becomes the type plus the short name: Pix Sicredi.',
    excluirTitulo: 'Delete this payment method?',
    excluirTexto: 'It leaves the list. A method used by another module is not deleted.',
    campos: { nome: 'Name', tipo: 'Type', abreviatura: 'Short name', descricao: 'Description', ativa: 'Active' },
    tipos: { pix: 'Pix', boleto: 'Bank slip', transferencia: 'Bank transfer', cartao_credito: 'Credit card', cartao_debito: 'Debit card', dinheiro: 'Cash', cheque: 'Check', outro: 'Other' },
  },
  condicoes: {
    nova: 'New term',
    importar: 'Import payment terms',
    vazio: 'Add named terms, such as "30, 60 and 90 days". The code is the same one Payables, Receivables and Purchasing already use.',
    excluirTitulo: 'Delete this payment term?',
    excluirTexto: 'It leaves the list. Documents that already use the code do not change.',
    campos: { nome: 'Name', codigo: 'Code', prazos: 'Due dates', ativa: 'Active' },
    ajudaCodigo: 'avista, 30 or 30/60/90 (days after the base date, in ascending order).',
    avista: 'Upfront',
    dias_one: '{{count}} day',
    dias_other: '{{count}} days',
  },
};

export const catalogosEs: Dic = {
  servicos: {
    novo: 'Nuevo servicio',
    importar: 'Importar servicios',
    vazio: 'Registra el primer servicio o importa una planilla. El catálogo sirve para vender y para comprar, y la Agenda usa los agendables.',
    excluir: 'Eliminar',
    excluirTitulo: '¿Eliminar este servicio?',
    excluirTexto: 'Sale del catálogo. Un servicio en uso por otro módulo no se elimina; el mensaje dice dónde está en uso.',
    campos: {
      nome: 'Nombre', codigo: 'Código', descricao: 'Descripción', uso: 'Uso', agendavel: 'Agendable', preco: 'Precio de venta', custo: 'Costo',
      tipoCobranca: 'Cobro', centro: 'Centro de costo por defecto', categoria: 'Categoría por defecto', ativo: 'Activo', margem: 'Margen',
      duracao: 'Duración (min)', quemFaz: 'Quién lo hace en la Agenda',
    },
    ajuda: {
      padrao: 'Solo una sugerencia para quien use el servicio; se puede cambiar en el documento.',
      agendavel: 'Aparece para quien agenda.',
      duracao: 'Tiempo que ocupa la cita. Sin valor, la Agenda usa 60 minutos.',
      quemFaz: 'Sin marcar ninguno, cualquier profesional o recurso activo hace el servicio.',
    },
    usos: { venda: 'Venta', compra: 'Compra', ambos: 'Venta y compra' },
    cobrancas: { recorrente: 'Recurrente', avulso: 'Puntual' },
    filtros: { uso: 'Uso', todos: 'Todos los usos' },
  },
  contratados: {
    novo: 'Nuevo servicio',
    importar: 'Importar servicios contratados',
    vazio: 'Registra los servicios que la empresa contrata a terceros, como contabilidad, limpieza o hosting. La compra sugiere la categoría de gasto y el proveedor de cada uno.',
    excluirTitulo: '¿Eliminar este servicio contratado?',
    excluirTexto: 'Va a la papelera por 30 días. Un servicio en uso por otro módulo no se elimina; el mensaje dice dónde está en uso.',
    campos: { nome: 'Nombre', descricao: 'Descripción', categoria: 'Categoría de gasto', fornecedor: 'Proveedor predeterminado', valorReferencia: 'Valor de referencia', ativo: 'Activo' },
    ajuda: { categoria: 'Del plan de cuentas de Finanzas. Sugerencia para la compra; puedes cambiarla en el ítem.', fornecedor: 'Opcional. Sugerencia para quien compra el servicio.', valorReferencia: 'Opcional. La compra sugiere este valor en el ítem; puedes cambiarlo.' },
    filtros: { situacao: 'Situación', ativos: 'Activos', inativos: 'Inactivos', todos: 'Todos' },
  },
  formas: {
    nova: 'Nueva forma',
    importar: 'Importar formas de pago',
    vazio: 'Registra los medios de pago por el tipo y la abreviatura, como Pix Sicredi o Boleto Asaas. Puedes tener más de uno del mismo tipo, con abreviaturas distintas.',
    ajudaAbreviatura: 'Distingue formas del mismo tipo, como Sicredi o Itaú. El nombre queda el tipo más la abreviatura: Pix Sicredi.',
    excluirTitulo: '¿Eliminar esta forma de pago?',
    excluirTexto: 'Sale de la lista. Una forma en uso por otro módulo no se elimina.',
    campos: { nome: 'Nombre', tipo: 'Tipo', abreviatura: 'Abreviatura', descricao: 'Descripción', ativa: 'Activa' },
    tipos: { pix: 'Pix', boleto: 'Boleto', transferencia: 'Transferencia', cartao_credito: 'Tarjeta de crédito', cartao_debito: 'Tarjeta de débito', dinheiro: 'Efectivo', cheque: 'Cheque', outro: 'Otro' },
  },
  condicoes: {
    nova: 'Nueva condición',
    importar: 'Importar condiciones de pago',
    vazio: 'Registra los plazos con nombre, como "30, 60 y 90 días". El código es el mismo que Cuentas y Compras ya usan.',
    excluirTitulo: '¿Eliminar esta condición de pago?',
    excluirTexto: 'Sale de la lista. Los documentos que ya usan el código no cambian.',
    campos: { nome: 'Nombre', codigo: 'Código', prazos: 'Plazos', ativa: 'Activa' },
    ajudaCodigo: 'avista, 30 o 30/60/90 (días después de la fecha base, en orden creciente).',
    avista: 'Al contado',
    dias_one: '{{count}} día',
    dias_other: '{{count}} días',
  },
};
